// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_SzvXn {
  display : flex;
  flex-direction : row;
  height : 100%;
  align-items : center;
  justify-content: center;
}

.content_SzvXn > * { 
  margin : var( --size-padXLarge, 24px );
}

.fontIcon_jTHEP {
  font-size : 200px;
  color : var( --color-lostColor, var( --color-brand800, #333333 ) )
}

.continue_f6zwU {
  margin-top : var( --size-padLarge, 16px );
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/support/LostScreen.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":[".content {\n  display : flex;\n  flex-direction : row;\n  height : 100%;\n  align-items : center;\n  justify-content: center;\n}\n\n.content > * { \n  margin : var( --size-padXLarge, 24px );\n}\n\n.fontIcon {\n  font-size : 200px;\n  color : var( --color-lostColor, var( --color-brand800, #333333 ) )\n}\n\n.continue {\n  margin-top : var( --size-padLarge, 16px );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_SzvXn`,
	"fontIcon": `fontIcon_jTHEP`,
	"continue": `continue_f6zwU`
};
export default ___CSS_LOADER_EXPORT___;
